import { render, staticRenderFns } from "./_shared.html?vue&type=template&id=dd2557b6&"
import script from "./Carrocerias.vue?vue&type=script&lang=js&"
export * from "./Carrocerias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports